import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { FiDropdownItemDisabledFn } from '@fi-app/shared/fi-select-search/fi-select-search';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { ILightWeightObject } from '@fi-shared/models';

@Component({
    selector: 'fi-roles-select-search',
    templateUrl: './fi-roles-select-search.component.html',
    styleUrls: ['./fi-roles-select-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-roles-select-search' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiRolesSelectSearchComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiRolesSelectSearchComponent,
            multi: true,
        },
    ],
})
export class FiRolesSelectSearchComponent extends ControlValueAccessorValidatorBase<number[]> {
    @Input() roles: ILightWeightObject[] = [];
    @Input() isRequired = false;
    @Input() headingText: string;
    @Input() descriptionText: string;
    @Input() errorText: string;

    isOptionDisabledFn: FiDropdownItemDisabledFn<ILightWeightObject> = (item: ILightWeightObject) => {
        return item.IsActivated;
    };

    public doValidate(): ValidationErrors {
        return { 'roles-not-selected': this.isRequired && !this.ngModel.length };
    }
}
